<script>
  import { onMount } from 'svelte';
  import { navigate } from "svelte-navigator";
  import { slide } from 'svelte/transition';
  import { Button, Switch, TextField } from "smelte";
  import { Tabs, Tab, TabList, TabPanel } from 'svelte-tabs';
  import Exporter from 'components/exporter/Exporter.svelte';
  import { prefilledReportContent, exportTitle, exportType } from "store";
  import { fetchReportFile, processReportFile, getCurrentDateTimeAsString } from 'utils';

  let amountAdrOffenses, report;
  let cilinders = [];
  let emptyCilinder = {
    indicated_weight: '',
    measured_weight: '', 
    level_filled: '', 
    offense_no_label: '',
    offense_wrong_label: '',
    offense_no_un_number: '',
    offense_wrong_un_number: '',
    offense_no_name: ''
  };
  let newCilinder = {};

  $: amountAdrOffenses = adr_offenses.filter(t => t.enabled).length;
  $: adr_info.adr_offenses = adr_offenses;
  $: adr_info.cilinders = cilinders;
  $: adr_info.total_kg = cilinders.reduce((acc, cil) => Number(acc) + Number(cil.indicated_weight), 0);

  onMount(() => {
    exportType.set("infosheet");
  });

  let adr_info = {
    start_datetime: getCurrentDateTimeAsString(),
    end_datetime: getCurrentDateTimeAsString(),
    location: "",
    licenseplate: "",
    vehicle_type: "Open voertuig",
    reason: "",
    comments: "",
    document_shown: false,
    exception: "",
    total_tanks: 0,
    total_full: 0,
    total_empty: 0,
    total_partly_filled: 0,
    total_kg: 0,
    overview_tanks: "",
    persons_involved: ""

  };

  let adr_categories = [
    "Vervoersdocument", "Opleiding", "Brandblusmiddelen", "Ventilatie", "Stuwage", "Etiketten / UN-nummer"
  ];

  let adr_offenses = [
    {
      category: "Vervoersdocument",
      adr_category: 0,
      title: "Vervoersdocument niet aanwezig/niet leesbaar",
      description: "",
      enabled: false,
      amount: 0,
      article: "ADR 8.1.2.1 a)",
      risk: "I",
      responsible: "afzender, vervoerder, belader"
    },
    {
      category: "",
      adr_category: 0,
      title: "Geen of onjuist UN-nummer, vervoersnaam of etiketnummer",
      description: "",
      enabled: false,
      amount: 0,
      article: "ADR 5.4.1.1.1",
      risk: "I",
      responsible: "afzender, vervoerder, belader"
    },
    {
      category: "",
      adr_category: 0,
      title: "Geen of onjuist aantal/omschrijving colli/bruto massa/afzender/geadresseerde",
      description: "",
      enabled: false,
      amount: 0,
      article: "ADR 5.4.1.1.1",
      risk: "III",
      responsible: "afzender, vervoerder, belader"
    },
    {
      category: "Opleiding",
      adr_category: 1,
      title: "Personeel niet (conform) opgeleid",
      description: "",
      enabled: false,
      amount: 0,
      article: "ADR 1.3.1",
      risk: "III",
      responsible: "afzender, vervoerder, belader, verpakker"
    },
    {
      category: "Brandblusmiddelen",
      adr_category: 2,
      title: "Geen of niet werkende brandblusmiddelen",
      description: "",
      enabled: false,
      amount: 0,
      article: "ADR 8.1.4.2",
      risk: "II",
      responsible: "vervoerder"
    },
    {
      category: "",
      adr_category: 2,
      title: "Niet voorzien van merkteken en/of verzegeling",
      description: "",
      enabled: false,
      amount: 0,
      article: "ADR 8.1.4.4",
      risk: "III",
      responsible: "vervoerder"
    },
    {
      category: "",
      adr_category: 2,
      title: "Niet gemakkelijk voorhanden, keuringsdatum vertreken",
      description: "",
      enabled: false,
      amount: 0,
      article: "ADR 8.1.4.5",
      risk: "III",
      responsible: "vervoerder"
    },
    {
      category: "Ventilatie",
      adr_category: 3,
      title: "Ventilatie ontbreekt of kenmerk niet aangebracht",
      description: "",
      enabled: false,
      amount: 0,
      article: "ADR 7.5.11",
      risk: "II",
      responsible: "vervoerder, belader"
    },
    {
      category: "",
      adr_category: 3,
      title: "(CV36) Lekkage (gas) van laadcompartiment naar bestuurderscabine mogelijk",
      description: "",
      enabled: false,
      amount: 0,
      article: "ADR 7.5.11",
      risk: "II",
      responsible: "vervoerder"
    },
    {
      category: "Stuwage",
      adr_category: 4,
      title: "Niet op een juiste wijze lading gestuwd (gezekerd)",
      description: "",
      enabled: false,
      amount: 0,
      article: "ADR 7.5.11",
      risk: "I",
      responsible: "vervoerder, belader"
    },
    {
      category: "",
      adr_category: 4,
      title: "(CV9) Niet op juiste wijze behandelen van cilinders (gooien/schokken)",
      description: "",
      enabled: false,
      amount: 0,
      article: "ADR 7.5.11",
      risk: "I",
      responsible: "vervoerder, belader"
    },
    {
      category: "",
      adr_category: 4,
      title: "(CV10) Positie cilinders en borging, vastzitten of vastmaken",
      description: "",
      enabled: false,
      amount: 0,
      article: "ADR 7.5.11",
      risk: "I",
      responsible: "vervoerder, belader"
    },
    {
      category: "Etiketten / UN-nummer",
      adr_category: 5,
      title: "Oververpakking niet voorzien van etiketten of UN-nummer",
      description: "",
      enabled: false,
      amount: 0,
      article: "ADR 5.1.2.1",
      risk: "II",
      responsible: "afzender, belader, verpakker"
    },
    {
      category: "",
      adr_category: 5,
      title: "Geen etiket 2.2 en 5.1 op elke cilinder",
      description: "",
      enabled: false,
      amount: 0,
      article: "ADR 5.2.2.1.1",
      risk: "I",
      responsible: "afzender, belader, verpakker"
    },
    {
      category: "",
      adr_category: 5,
      title: "Onjuist etiket op cilinder",
      description: "",
      enabled: false,
      amount: 0,
      article: "ADR 5.2.2.1.1",
      risk: "II",
      responsible: "afzender, belader, verpakker"
    },
    {
      category: "",
      adr_category: 5,
      title: "Geen UN-nummer op elke cilinder",
      description: "",
      enabled: false,
      amount: 0,
      article: "ADR 5.2.1.1 ",
      risk: "I",
      responsible: "afzender, belader, verpakker"
    },
    {
      category: "",
      adr_category: 5,
      title: "Onjuist UN-nummer op cilinder",
      description: "",
      enabled: false,
      amount: 0,
      article: "ADR 5.2.1.1",
      risk: "II",
      responsible: "afzender, belader, verpakker"
    },
    {
      category: "",
      adr_category: 5,
      title: "Geen vervoersnaam op cilinder",
      description: "",
      enabled: false,
      amount: 0,
      article: "ADR 5.2.1.6 a)",
      risk: "II",
      responsible: "afzender, belader, verpakker"
    }
  ];

  function selectAdrReport() {
    exportType.set("conceptreport");
    // hardcoded adr concept report
    report = { path: "files/adr.yml" };
    let finalDoc = fetchReportFile(report.path).then(parsedDoc => 
      processReportFile(parsedDoc)
    ).then(processedDoc =>
      preFillConceptReport(processedDoc)
    ).then(
      redirectToConceptReport()
    );
  };
  
  function preFillConceptReport(doc) {
    exportTitle.set(doc.title);
    prefilledReportContent.set(doc.report);
  };

  function redirectToConceptReport() {
    navigate("/conceptpv");
  };

  function addCilinderToList() {
    cilinders = [...cilinders, newCilinder];
		newCilinder = { indicated_weight: newCilinder.indicated_weight, level_filled: newCilinder.level_filled };
  };

  function removeFromCilinders(index) {
		cilinders.splice(index, 1)
		cilinders = cilinders;
  }

</script>
<main>
  
  <div class="mx-2">
    
    <h1 class="text-xl font-bold">
      ADR Lachgas
    </h1>
    <Tabs>
      <TabList>
        <Tab>Checklist</Tab>
        <Tab>Overtredingen (<b>{amountAdrOffenses}</b>)</Tab>
        <Tab>Genereer PV</Tab>
      </TabList>
     
      <TabPanel>
        {#each adr_offenses as offense}
        <div class="mb-4">
          {#if offense.category}
          <h1 class="font-bold mb-4">
            {offense.category}
          </h1>
          {/if}
          <div class="flex flex-col justify-between">
            <span>
              <Switch
                bind:value={offense.enabled}
                label={offense.title}
                labelClasses="text-sm ml-2 text-gray-900"
                />
              </span>
            <span class="text-sm text-gray-500" id="availability-description">{offense.article} - risicocat. {offense.risk} - verantwoordelijk: {offense.responsible}</span>
          </div>
        </div>
        {/each}

      </TabPanel>
     
      <TabPanel>
        <div class="mb-4">
          <h1 class="font-bold mb-2">
            Geconstateerde overtredingen
          </h1>

          <div class="mb-2 bg-white shadow sm:rounded-lg">
            <div class="px-4 py-5 sm:p-6 text-base text-gray-900">
              {#if amountAdrOffenses < 1}
              <p>Er zijn <u>geen overtredingen</u> geconstateerd.</p>
              {:else if amountAdrOffenses === 1}1
              <p>Er is <u>1 overtreding</u> geconstateerd:</p>
              {:else}
              <p>Er zijn <u>{amountAdrOffenses} overtredingen</u> geconstateerd:</p>
              {/if}
              
              <ul class="mt-2">
                {#each adr_offenses.filter(t => t.enabled) as offense}
                <li class="mb-2">
                  <b>{offense.article}</b> - {offense.title}<br />
                </li>
                {/each}
              </ul>
            </div>
          </div>
        </div>

        <div class="mb-4">
          <h1 class="font-bold mb-2">
            Aangetroffen drukhouders
          </h1>

          <div class="mb-2 bg-white shadow sm:rounded-lg">
            <div class="px-4 py-5 sm:p-6 text-base text-gray-900">
              <h3 class="text-base font-medium leading-6 text-gray-900">Voeg cilinder toe</h3>
              <form on:submit|preventDefault={addCilinderToList}>
                <table class="mb-5 mt-2 divide-y border-spacing-x-1 divide-gray-200">
                  <tr class="bg-gray-50">
                    <td><label for="new_indicated_weight">Netto (vul)gewicht</label><br />
                      <span class="text-gray-500">
                        Let op: Netto (vul)gewicht is nooit<br />groter dan waterinhoud in liters.
                      </span>
                    </td>
                    <td>
                      <select id="new_indicated_weight" bind:value={newCilinder.indicated_weight}>
                        <option value="2.0" selected>2.0 kg (2,7 liter)</option>
                        <option value="3.75">3.75 kg (5 liter)</option>
                        <option value="4.0">4.0 kg (+/-5 liter)</option>
                        <option value="7.5">7.5 kg (10 liter)</option>
                        <option value="10.0">10.0 kg (13.5 liter)</option>
                      </select>
                    </td>
                  </tr>
                  <tr class="bg-white">
                    <td><label for="new_level_filled">Inhoud drukhouder</label><br />
                      <span class="text-gray-500">
                        Gele dop? Vol<br />
                      </span>
                    <td>
                      <select id="new_level_filled" bind:value={newCilinder.level_filled}>
                        <option value="vol">Vol</option>
                        <option value="deels gevuld">Deels gevuld</option>
                        <option value="leeg">Leeg</option>
                      </select>
                    </td>
                  </tr>
                  <tr class="bg-gray-50">
                    <td><label for="new_indicated_weight">Etiketten op drukhouder</label><br />
                      <span class="text-gray-500">
                        2.2 + 5.1
                      </span>
                    </td>
                    <td>
                      <Switch
                        bind:value={newCilinder.offense_no_label}
                        label="Geen etiket"
                        labelClasses="text-sm ml-2 text-gray-900"
                      /><br />
                      <Switch
                        bind:value={newCilinder.offense_wrong_label}
                        label="Verkeerd etiket"
                        labelClasses="text-sm ml-2 text-gray-900"
                      />
                    </td>
                  </tr>
                  <tr class="bg-white">
                    <td><label for="new_indicated_weight">UN-nummer op drukhouder</label><br />
                      <span class="text-gray-500">
                        UN1070
                      </span>
                    </td>
                    <td>
                      <Switch
                        bind:value={newCilinder.offense_no_un_number}
                        label="Geen UN-nummer"
                        labelClasses="text-sm ml-2 text-gray-900"
                      /><br />
                      <Switch
                        bind:value={newCilinder.offense_wrong_un_number}
                        label="Verkeerd UN-nummer"
                        labelClasses="text-sm ml-2 text-gray-900"
                      />
                    </td>
                  </tr>
                  <tr class="bg-gray-50">
                    <td><label for="new_indicated_weight">Vervoersnaam op drukhouder:</label><br />
                      <span class="text-gray-500">
                        Distikstofoxide (Lachgas)
                      </span>
                    </td>
                    <td>
                      <Switch
                        bind:value={newCilinder.offense_no_name}
                        label="Geen vervoersnaam"
                        labelClasses="text-sm ml-2 text-gray-900"
                      />
                    </td>
                  </tr>
                </table>
                <Button type="submit">Voeg toe</Button>
              </form>
            </div>
          </div>

          <div class="mb-2 bg-white shadow sm:rounded-lg">
            <div class="flex flex-col">
              <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                  <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                    <table class="divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th scope="col" class="px-2 py-2 text-left text-xs text-gray-500 uppercase tracking-wider">
                            Nr.
                          </th>
                          <th scope="col" class="px-2 py-2 text-left text-xs text-gray-500 uppercase tracking-wider">
                            Netto (vul)gewicht
                          </th>
                          <th scope="col" class="px-2 py-2 text-left text-xs text-gray-500 uppercase tracking-wider">
                            Inhoud
                          </th>
                          <th scope="col" class="px-2 py-2 text-left text-xs text-gray-500 uppercase tracking-wider">
                            Etiketten
                          </th>
                          <th scope="col" class="px-2 py-2 text-left text-xs text-gray-500 uppercase tracking-wider">
                            UN-nummer
                          </th>
                          <th scope="col" class="px-2 py-2 text-left text-xs text-gray-500 uppercase tracking-wider">
                            Vervoersnaam
                          </th>
                          <th scope="col" class="px-2 py-2 text-left text-xs text-gray-500 uppercase tracking-wider">
                            Verwijder
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {#each cilinders as cilinder, index}
                        <tr class={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} transition:slide>
                          <td class="px-2 py-2 whitespace-nowrap text-left text-xs font-medium text-gray-900">
                            {index+1}
                          </td>
                          <td class="px-2 py-2 whitespace-nowrap text-left text-base font-medium text-gray-900">
                            <select bind:value={cilinder.indicated_weight}>
                              <option value="2.0">2.0 kg (2,7 liter)</option>
                              <option value="3.75">3.75 kg (5 liter)</option>
                              <option value="4.0">4.0 kg (+/-5 liter)</option>
                              <option value="7.5">7.5 kg (10 liter)</option>
                              <option value="10.0">10.0 kg (13.5 liter)</option>
                            </select>
                          </td>
                          <td class="px-2 py-2 whitespace-nowrap text-left text-base font-medium text-gray-900">
                            <select id="level_filled" bind:value={cilinder.level_filled}>
                              <option value="vol">Vol</option>
                              <option value="deels gevuld">Deels gevuld</option>
                              <option value="leeg">Leeg</option>
                            </select>
                          </td>
                          <td class="px-2 py-2 whitespace-nowrap text-left text-xs font-medium text-gray-900">
                            <Switch
                              bind:value={cilinder.offense_no_label}
                              label="Geen etiket"
                              labelClasses="text-sm ml-2 text-gray-900"
                            /><br />
                            <Switch
                              bind:value={cilinder.offense_wrong_label}
                              label="Verkeerd etiket"
                              labelClasses="text-sm ml-2 text-gray-900"
                            />
                          </td>
                          <td class="px-2 py-2 whitespace-nowrap text-left text-xs font-medium text-gray-900">
                            <Switch
                              bind:value={cilinder.offense_no_un_number}
                              label="Geen UN-nr"
                              labelClasses="text-sm ml-2 text-gray-900"
                            /><br />
                            <Switch
                              bind:value={cilinder.offense_wrong_un_number}
                              label="Verkeerd UN-nr"
                              labelClasses="text-sm ml-2 text-gray-900"
                            />
                          </td>
                          <td class="px-2 py-2 whitespace-nowrap text-left text-xs font-medium text-gray-900">
                            <Switch
                              bind:value={cilinder.offense_no_name}
                              label="Geen vervoersnaam"
                              labelClasses="text-sm ml-2 text-gray-900"
                            />
                          </td>
                          <td class="px-2 py-2 whitespace-nowrap text-left text-gray-500">
                            <span on:click={() => removeFromCilinders(index)}>❌</span>
                            <br/>
                          </td>
                        </tr>
                        {/each} 
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-4">
          <h1 class="font-bold">
            Totalen drukhouders
          </h1>
          <div class="mb-2 bg-white shadow sm:rounded-lg">
            <div class="px-4 py-5 sm:p-6 text-base text-gray-900">
              <TextField bind:value={adr_info.total_tanks} label="Totaal aantal aangetroffen drukhouders" hint="Bijv. 21" persistentHint color="blue" />
              <TextField bind:value={adr_info.total_full} label="Totaal volle drukhouders" hint="Bijv. 43" persistentHint color="blue" />
              <TextField bind:value={adr_info.total_empty} label="Totaal lege drukhouders" hint="Bijv. 5" persistentHint color="blue" />
              <TextField bind:value={adr_info.total_partly_filled} label="Totaal deels gevulde drukhouders" hint="Bijv. 8" persistentHint color="blue" />
              <TextField bind:value={adr_info.total_kg} label="Totaal aantal vervoerde KG lachgas" hint="Bijv. 5" persistentHint color="blue" />
              <!-- <TextField id="overview_tanks" label="Aantallen drukhouders, netto (vul)gewicht (kg), vol/leeg/deels gevuld. Bijv. 3x vol 2kg" textarea rows="5" outlined bind:value={adr_info.overview_tanks} /> -->
            </div>
          </div>
        </div>
        
      </TabPanel>

      <TabPanel>
        <div class="mb-4">
          <h1 class="font-bold">
            Gegevens controle/betrokkenen
          </h1>
          <div class="mb-2">
            <TextField id="datetime" bind:value={adr_info.start_datetime} label="Start datum/tijd van controle" hint="Bijv. 10-01-2023 16:00" persistentHint color="blue" />
            <TextField id="datetime" bind:value={adr_info.end_datetime} label="Einde datum/tijd van controle" hint="Bijv. 10-01-2023 16:30" persistentHint color="blue" />
            <TextField id="location" bind:value={adr_info.location} label="Locatie van controle" hint="Bijv. Diepenhorstlaan thv 4, Rijswijk" persistentHint color="blue" />
            <TextField id="licenseplate" bind:value={adr_info.licenseplate} label="Kenteken betrokken voertuig" hint="Bijv. G405FG" persistentHint color="blue" />
            <div class="mt-5 mb-5">
              <label class="ml-2 mr-10" for="vehicle_type">Inrichting voertuig</label>
              <select id="vehicle_type" bind:value={adr_info.vehicle_type}>
                <option value="Open voertuig">Open voertuig</option>
                <option value="Gesloten voertuig">Gesloten voertuig</option>
                <option value="Dekzeil">Dekzeil</option>
                <option value="Tankwagen">Tankwagen</option>
                <option value="Druk-vacuumtank">Druk-vacuumtank</option>
                <option value="Batterijwagen">Batterijwagen</option>
              </select>
            </div>
            <TextField id="reason" bind:value={adr_info.reason} label="Aanleiding onderzoek" hint="Controle Wvgs (bijv ivm oranje bord) / Andere aanleiding (bijv 160wvw of een melding)" persistentHint color="blue" />
          </div>
          <div class="mb-2">
            <p class="text-gray-900">
              Betrokken personen:
            </p>
            <TextField id="persons_involved" label="Overzicht betrokkenen: naam, geboortedatum, geboorteplaats, bsn; rollen" textarea rows="2" outlined bind:value={adr_info.persons_involved} hint="Rollen: afzender, vervoerder, belader, verpakker" persistentHint color="blue" />
          </div>
        </div>
        
        <div class="mb-4">
          <h1 class="font-bold mb-4">
            Algemeen
          </h1>

          <div class="mb-2 text-gray-900">
            <p>
              Overhandigt de betrokkene een vervoersdocument?
            </p>
            <Switch
              bind:value={adr_info.document_shown}
              label="Vervoersdocument is overhandigd"
              labelClasses="text-sm ml-2 text-gray-900"
            />
          </div>
          <div class="flex flex-col justify-between mb-2 text-gray-900">
            <p>Sprake van vrijstelling?</p>
            <label class="text-sm ml-2 text-gray-900">
              <input type=radio bind:group={adr_info.exception} value="Geen algemene vrijstelling">
              Geen sprake van algemene vrijstelling 1.1.3 ADR
            </label>
            <label class="text-sm ml-2 text-gray-900">
              <input type=radio bind:group={adr_info.exception} value="Wel gedeeltelijke vrijstelling (1000 punten regeling)">
              Wel sprake van GEDEELTELIJKE vrijstelling 1.1.3 ADR (1000 puntenregeling)
            </label>
            <label class="text-sm ml-2 text-gray-900">
              <input type=radio bind:group={adr_info.exception} value="Geen gedeeltelijke vrijstelling (1000 punten regeling)">
              Geen sprake van GEDEELTELIJKE vrijstelling 1.1.3 ADR (1000 puntenregeling)
            </label>
          </div>
          
          <div class="flex flex-col justify-between mb-2 text-gray-900">
            <p>Overige opmerkingen/bevindingen tbv BVH:</p>
            <TextField id="comments" label="Bevindingen onderzoek" textarea rows="3" outlined bind:value={adr_info.comments} hint="Waar zijn drukhouders aangetroffen? Waren wel of niet van ingeslagen opschriften voorzien?" persistentHint color="blue" />
          </div>
        </div>
        
        <div class="mb-4">
          <h1 class="font-bold">
            Afhandeling
          </h1>
          <p>
            Nog 2 stappen te gaan, download de PDF met controle-info voor je BVH-registratie.<br />
            Na het downloaden van de info, kun je de verdachte horen. Gebruik hiervoor het concept-pv verhoor; het verhoor wordt al gevuld met basisvragen, afhankelijk van geconstateerde overtredingen.
          </p>
        </div>
        <h2 class="font-bold">
          Stap 1: Download informatie ADR-controle
        </h2>
        <div class="mb-4">
          <Exporter info={adr_info} buttonText="Download controle-informatie" />
          <h2 class="font-bold">
            Stap 2: Vul concept-pv verhoor met vragen en hoor de verdachte
          </h2>
          <Button on:click={selectAdrReport}>Concept-PV verhoor verdachte</Button>
        </div>
      </TabPanel>
    </Tabs>
  </div>
</main>

<style>
  
</style>